<div *ngIf="activeFeatureDims$ | async as activeFeature" [id]="dropdownId">
  <li class="nav-item">
    <a [routerLink]="['/settings', 'user']" class="nav-link"
      ><i class="icon-wrench me-2"></i> {{ 'header_menu.user_settings' | translate }}</a
    >
  </li>
  <li *ngIf="customerName$ | async as customerName" class="nav-item">
    <a [routerLink]="['/settings', 'customer']" class="nav-link">
      <i class="icon-wrench me-2"></i>
      {{ 'header_menu.customer_settings' | translate: { customerName: customerName } }}
    </a>
  </li>

  <li *ngIf="activeFeature.flags.custom_company_report" class="nav-item">
    <a [routerLink]="['/files', 'templates']" class="nav-link">
      <i class="icon-folder me-2"></i> {{ 'header_menu.template_manager' | translate }}
    </a>
  </li>

  <li *ngIf="(appMembershipList$ | async)?.length > 0" class="nav-item">
    <div (click)="onChangeAccount()" class="nav-link">
      <i class="icon-refresh me-2"></i> {{ 'header_menu.change_user_account' | translate }}
    </div>
  </li>

  <li *ngIf="!loggedInWithIdentityProvider" class="nav-item">
    <div (click)="logout()" class="nav-link">
      <i class="icon-logout me-2"></i> {{ 'header_menu.logout' | translate }}
    </div>
  </li>
  <li *ngIf="loggedInWithIdentityProvider && !hideNavItems['logoutMicrosoft']" class="nav-item">
    <div (click)="logout()" class="nav-link">
      <i class="icon-logout me-2"></i> {{ 'header_menu.logout_of_enin' | translate }}
    </div>
  </li>
</div>
